import React from 'react';
import { useQuery } from '@apollo/client';
import { GetViewerLearningDetailsDocument } from '@sandtech-hub-monorepo/ehub-client';
import { Loading } from '@sandtech-hub-monorepo/ui-kit-site';
import { HomeNotEnrolled } from './sections/HomeNotEnrolled';
import { HomeEnrolled } from './sections/HomeEnrolled';
import { getDisplayableEnrollments } from './utils';

const Home = () => {
  const { data } = useQuery(GetViewerLearningDetailsDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data) {
    return <Loading />;
  }

  const displayableEnrollments = getDisplayableEnrollments(
    data.viewer.programEnrollments ?? []
  );
  return displayableEnrollments.length ? <HomeEnrolled /> : <HomeNotEnrolled />;
};

export default Home;
